import { StyleSheet } from "react-native";
import theme from "../theme";
import { dynamicSize } from "../helpers";

export default StyleSheet.create({
  modal: {
    backgroundColor: theme.colors.grey2,
    flex: 1,
    padding: dynamicSize(20),
    marginVertical: dynamicSize(50),
    marginHorizontal: dynamicSize(20)
  }
});
